var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIconBlackCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237.4 237.4",
    style: {
      enableBackground: "new 0 0 237.4 237.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010202;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.7,0C53.1,0,0,53.1,0,118.7s53.1,118.7,118.7,118.7s118.7-53.1,118.7-118.7S184.2,0,118.7,0z M153.6,72 c0,0-11.8,0-16.5,0c-5.8,0-7,2.4-7,8.4c0,5,0,14.5,0,14.5h23.5l-2.3,25.5H130v76.3H99.5v-76H83.6V94.8h15.9c0,0,0-3.7,0-20.4 c0-19.1,10.3-29.1,32.9-29.1c3.7,0,21.1,0,21.1,0L153.6,72L153.6,72z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconBlackCircle);
export default __webpack_public_path__ + "static/media/facebook-icon-black-circle.9606d3657905bfcea869b9998dcc429f.svg";
export { ForwardRef as ReactComponent };